import React from "react";
import { Link } from "react-router-dom";
import "./Service.css";

export default function Service() {
  // Fatherhood programming image from Pexels
  const serviceImageUrl =
    "/fa.jpg";

  return (
    <section className="cis-service" id="service" aria-labelledby="service-title">
      <div className="cis-service__container">
        <header className="cis-service__header">
          <h1 id="service-title" className="cis-service__mainTitle">
            Enhance Family Engagement and Community Wellbeing Today
          </h1>
        </header>

        {/* TOP GRID: Content + Image */}
        <div className="cis-service__gridTop">
          {/* Left Column - Content */}
          <div className="cis-service__content">
            {/* ✅ Single combined box */}
            <div className="cis-service__box">
              <h2 className="cis-service__title">ProFathering15™: A Free Online Program for Dads</h2>

              <p className="cis-service__text">
                Become the dad your child needs. You matter more than you think. Your presence, your
                voice, and your example all shape your child's future in powerful ways.
              </p>

              <p className="cis-service__text">
                We're offering ProFathering15™, a free online fatherhood program designed to help you
                grow as a father, strengthen your family relationships, and build a future you're
                proud of. There's no judgment and no lectures, just real tools for real dads who want
                to show up and do their best.
              </p>

              <h3 className="cis-service__subtitle">What Is ProFathering15™?</h3>

              <p className="cis-service__text">
                ProFathering15™ is a 15-topic online program that helps fathers build confidence,
                improve communication, manage stress, and strengthen their parenting skills. Each
                topic takes about 15 minutes to complete, and you can move through the program at
                your own pace on your phone, tablet, or computer.
              </p>

              <p className="cis-service__text">
                Throughout the program, you'll gain practical tools for handling emotions and stress,
                improving co-parenting and communication, understanding child development and
                discipline, balancing work and family life, managing money, and becoming the father
                you want to be.
              </p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="cis-service__imageColumn cis-service__imageColumn--tall">
            <div className="cis-service__imageWrapper cis-service__imageWrapper--tall">
              <div className="cis-service__imageContainer">
                <img
                  className="cis-service__image cis-service__image--cover"
                  src={serviceImageUrl}
                  alt="Father spending quality time with his children"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM ROW: Audience Box + Features Grid IN A ROW */}
        <div className="cis-service__rowGrid">
          {/* Audience Box */}
          <div className="cis-service__box cis-service__box--stretch">
            <h3 className="cis-service__subtitle">This program is for you if:</h3>
            <ul className="cis-service__list">
              <li className="cis-service__listItem">You're a dad who wants to do better</li>
              <li className="cis-service__listItem">Rebuilding after mistakes</li>
              <li className="cis-service__listItem">Navigating co-parenting</li>
              <li className="cis-service__listItem">Involved in child support</li>
              <li className="cis-service__listItem">A young father figuring things out</li>
              <li className="cis-service__listItem">
                Preparing to reenter your family after incarceration
              </li>
            </ul>
          </div>

          {/* Features Grid */}
          <div className="cis-service__featuresGrid cis-service__featuresGrid--stretch">
            <div className="cis-service__feature">
              <span className="cis-service__checkmark">✅</span>
              <span className="cis-service__featureText">100% FREE enrollment</span>
            </div>
            <div className="cis-service__feature">
              <span className="cis-service__checkmark">✅</span>
              <span className="cis-service__featureText">15 short online modules</span>
            </div>
            <div className="cis-service__feature">
              <span className="cis-service__checkmark">✅</span>
              <span className="cis-service__featureText">Self-paced access</span>
            </div>
            <div className="cis-service__feature">
              <span className="cis-service__checkmark">✅</span>
              <span className="cis-service__featureText">Support from our team</span>
            </div>
            <div className="cis-service__feature">
              <span className="cis-service__checkmark">✅</span>
              <span className="cis-service__featureText">Certificate of Completion</span>
            </div>
          </div>
        </div>

        {/* Button centered below */}
        <div className="cis-service__buttonWrap cis-service__buttonWrap--center">
          <Link to="/contact" className="cis-service__button">
            Enroll Now
          </Link>
        </div>
      </div>
    </section>
  );
}